import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/vantaggi', label: 'Vantaggi ESG' },
  { to: '/about', label: 'Chi siamo' },
  { to: '/faq', label: 'FAQ' },
  { to: '/contatti', label: 'Contatti' },
];

const hideButtonsOn = ['/login', '/register'];

export default function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const showButtons = !hideButtonsOn.includes(location.pathname);

  return (
    <>
      <style>{`
        .nav-link {
          font-size: 14px;
          font-weight: 400;
          color: #3B3B35;
          text-decoration: none;
          padding: 4px 0;
          position: relative;
          transition: color 0.15s;
        }
        .nav-link::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 2px;
          background: #1D9E75;
          transition: width 0.2s;
          border-radius: 1px;
        }
        .nav-link:hover { color: #1D9E75; }
        .nav-link:hover::after { width: 100%; }
        .nav-link.active { color: #1D9E75; font-weight: 500; }
        .nav-link.active::after { width: 100%; }

        .mobile-menu {
          display: none;
          flex-direction: column;
          gap: 4px;
          padding: 12px 24px 20px;
          background: white;
          border-top: 1px solid #E0DED6;
        }
        .mobile-menu.open { display: flex; }
        .mobile-nav-link {
          font-size: 15px;
          color: #3B3B35;
          text-decoration: none;
          padding: 10px 0;
          border-bottom: 1px solid #F0EEE8;
          font-weight: 400;
        }
        .mobile-nav-link:last-of-type { border-bottom: none; }
        .mobile-nav-link:hover { color: #1D9E75; }
        .mobile-nav-link.active { color: #1D9E75; font-weight: 500; }
        .mobile-buttons {
          display: flex;
          gap: 8px;
          padding-top: 12px;
        }
        .hamburger {
          display: none;
          flex-direction: column;
          gap: 5px;
          cursor: pointer;
          padding: 4px;
          background: none;
          border: none;
        }
        .hamburger span {
          display: block;
          width: 22px;
          height: 2px;
          background: #3B3B35;
          border-radius: 1px;
          transition: all 0.2s;
        }
        .hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
        .hamburger.open span:nth-child(2) { opacity: 0; }
        .hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

        @media (max-width: 768px) {
          .nav-links-desktop { display: none !important; }
          .hamburger { display: flex; }
        }
        @media (min-width: 769px) {
          .mobile-menu { display: none !important; }
        }
      `}</style>

      <nav style={{ background: 'white', borderBottom: '1px solid #E0DED6', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

          {/* Logo */}
          <Link to="/" style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <img src='/Logo_or.png' alt='ESGcert' style={{ height: 36 }} />
          </Link>

          {/* Nav links desktop */}
          <div className="nav-links-desktop" style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`nav-link${location.pathname === link.to ? ' active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Right side */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {showButtons && (
              <div className="nav-links-desktop" style={{ display: 'flex', gap: 8 }}>
                <Link to="/login" className="btn btn-outline btn-sm">Accedi</Link>
                <Link to="/register" className="btn btn-primary btn-sm">Registrati</Link>
              </div>
            )}
            {/* Hamburger */}
            <button
              className={`hamburger${menuOpen ? ' open' : ''}`}
              onClick={() => setMenuOpen(o => !o)}
              aria-label="Menu"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`mobile-nav-link${location.pathname === link.to ? ' active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          {showButtons && (
            <div className="mobile-buttons">
              <Link to="/login" className="btn btn-outline btn-sm" onClick={() => setMenuOpen(false)}>Accedi</Link>
              <Link to="/register" className="btn btn-primary btn-sm" onClick={() => setMenuOpen(false)}>Registrati</Link>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
